import React from 'react';

type Props = {
  isLocked: boolean;
  lockedByName?: string | null;
};

export const LockWarningBar: React.FC<Props> = ({ isLocked, lockedByName }) => {
  if (!isLocked) return null;

  const message = lockedByName
    ? `${lockedByName} さんが編集中のため、この画面は閲覧のみ可能です。`
    : '別のユーザーが編集中のため、この画面は閲覧のみ可能です。';

  return (
    <div
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 1300,
        width: '100%',
        backgroundColor: '#fff3cd',
        color: '#856404',
        padding: '8px 16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: 14,
        borderBottom: '1px solid #ffeeba',
      }}
    >
      {message}
    </div>
  );
};
